import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconData", "height", "width", "onIconSelect", "display", "theme"];
import { PureComponent } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import styled from 'foundations-theming/utils';
import withTheme from 'ContentComponents/cmv2/decorators/withTheme';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSvg = styled.svg.withConfig({
  displayName: "Icon__StyledSvg",
  componentId: "sc-7fgma2-0"
})(({
  iconHeight: height,
  iconWidth: width
}) => {
  return {
    height,
    width,
    display: 'block'
  };
});
class Icon extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        iconData,
        height,
        width,
        onIconSelect = emptyFunction,
        display,
        theme
      } = _this$props,
      spaceStyleProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      name,
      svg,
      viewPort
    } = iconData;
    const {
      color = theme.color['icon-core-default']
    } = this.props;
    const renderedSvg = /*#__PURE__*/_jsx(StyledSvg, {
      iconHeight: height,
      iconWidth: width,
      viewBox: viewPort ? viewPort.join(' ') : '',
      role: "img",
      "aria-label": name,
      children: /*#__PURE__*/_jsx("path", {
        fill: color,
        d: svg
      })
    });
    return display === 'flex' ? /*#__PURE__*/_jsx(Flex, Object.assign({
      "data-test-id": "cmv2-icon",
      "data-value": name,
      onClick: () => onIconSelect(iconData)
    }, spaceStyleProps, {
      children: renderedSvg
    })) : /*#__PURE__*/_jsx(View, Object.assign({
      "data-test-id": "cmv2-icon",
      "data-value": name,
      onClick: () => onIconSelect(iconData),
      display: display
    }, spaceStyleProps, {
      children: renderedSvg
    }));
  }
}
Icon.defaultProps = {
  height: 25,
  width: 25
};
export default withTheme(Icon);